module.exports = __webpack_public_path__ + "img/N+1管家陪伴式运作.987252cd.png";